// frontend/src/components/MeetingTemplateForm/MeetingTemplateForm.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import apiClient from '../../apiClient';
import './MeetingTemplateForm.css';

function MeetingTemplateForm() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [templateName, setTemplateName] = useState('');
  const [prompt, setPrompt] = useState('');
  const [clinicId, setClinicId] = useState('');
  const [clinics, setClinics] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ----- fetch clinics ----- */
  useEffect(() => {
    apiClient.get('/api/clinics').then(res => setClinics(res.data));
  }, []);

  /* ----- load template when editing ----- */
  useEffect(() => {
    if (!id) return;
    setLoading(true);
    apiClient.get(`/api/meetingmallar/${id}`)
      .then(res => {
        const t = res.data;
        setTemplateName(t.template_name);
        setPrompt(t.prompt);
        setClinicId(t.clinic_id?.toString() || '');
      })
      .catch(() => alert('Kunde inte ladda mötesmallen'))
      .finally(() => setLoading(false));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      template_name: templateName,
      prompt,
      clinic_id: parseInt(clinicId, 10)
    };
    try {
      if (id) {
        await apiClient.put(`/api/meetingmallar/${id}`, data);
        alert('Mötesmall uppdaterad');
      } else {
        await apiClient.post('/api/meetingmallar', data);
        alert('Mötesmall skapad');
      }
      navigate('/meetingmallar');
    } catch {
      alert('Kunde inte spara mötesmallen');
    }
  };

  if (loading) return <div>Laddar...</div>;

  return (
    <div className="meeting-template-form-container">
      <h2>{id ? 'Redigera mötesmall' : 'Skapa ny mötesmall'}</h2>

      <form onSubmit={handleSubmit} className="form-content">
        <div className="form-group">
          <label>Mallnamn</label>
          <input
            className="template-name-input"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Klinik</label>
          <select
            className="clinic-select"
            value={clinicId}
            onChange={(e) => setClinicId(e.target.value)}
            required
          >
            <option value="">-- Välj klinik --</option>
            {clinics.map(c => (
              <option key={c.clinic_id} value={c.clinic_id}>{c.clinic_name}</option>
            ))}
          </select>
        </div>

        <div className="prompt-wrapper">
          <label>Prompt</label>
          <textarea
            className="prompt-textarea"
            rows={6}
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="save-button">Spara</button>
          <button type="button" className="cancel-button" onClick={() => navigate('/meetingmallar')}>
            Avbryt
          </button>
        </div>
      </form>
    </div>
  );
}

export default MeetingTemplateForm;
